// @ts-nocheck

import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { type Licence, Licences } from '../../types/common';
import { RoutePatterns } from '../../types/routes';
import PPROffer from '../PPROffer';

type LandingProps = {
  licence: Licence;
  newuser: boolean;
};

const Landing = ({ licence, newuser }: LandingProps) => {
  if (newuser && licence === Licences.FR) {
    return (
      <Switch>
        <Route path={RoutePatterns.HOME} exact>
          <PPROffer />
        </Route>
      </Switch>
    );
  }
  return null;
};

export default Landing;
